export default "__VITE_PUBLIC_ASSET__f1d9fcd4__"